module.exports = "/virtual-football-league/img/amblems/left/logos/Arsenal.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/amblems/left/logos/Arsenal.png
// module id = 2050
// module chunks = 4